let common = {
    error: "The application does not exist. Please check whether the application link is correct",
    code501:"Access restriction",
    spin: {
      	text: "Loading..."
    },
	push: {
		text: "Push",
		sendCode: "Send"
	},
	code: {
		get: "get code",
		emailCodePlaceholder: "Please enter the email verification code",
		msg6: "Please enter a 6-digit verification code",
		phoneCodePlaceholder: "Please enter the SMS verification code",
	},
	btn: {
		submit: "Confirm",
		search: "Search",
		reset: "Reset",
		read: "Mark all as read",
		edit: "Modification",
		subBtn: "Save",
		close: "Cancel",
		closeBtn: "Close",
		loading:"Loading.....",
		commit:"Submit",
	},
	pwd: {
		affirmPassword: "Please enter a valid Confirmation password",
		verifyPassword: "The entered passwords are inconsistent",
		newPwd: "Please enter a new password",
	},
	browser: {
		errorAuthentication: "Your browser does not support this authentication mode!",
		arouse: "The authenticator has been invoked!",
		overtime: "The user canceled the operation or timed out!",
		noWeb: "This browser does not support Web authentication!",
		secureConnection: "Web authentication supports only secure connections",
		authenticationMethod: "Please select an authentication method!",
		FIDO2Look: "FIDO2 authentication login failed: authenticator locked",
		FIDO2Err: "FIDO2 authentication login failed: authenticator not enabled",
		nonsupport: "Your browser does not currently support binding tokens!"
	},
	pagination: {
		from: "From",
		to: "To",
		aggregate: "Total",
		strip: "Strip",
		perPage:"Per page",
	},
	tailorImg: {
		title: "Avatar upload",
		uploadText: "Select Image",
		typeErr: "Please upload JPG and PNG images!",
		sizeErr: "Images cannot be larger than 200kb!",
		noFile: "Please choose a picture!"
	},
	header: {
		goOut: "Sign out",
		modalTitle: "Session is about to time out reminder",
		okText: "Continue to use",
		countdown: "Current remaining session duration",
		notification: "Notification",
		tip1: "You have",
		tip2: "Messages not viewed",
	}
}

export default common
